/**
 * @file 获取学员获取学习任务列表
 * @author liudy
 * {@link https://docs.google.com/document/d/1KJvE-27eDHJuWSjDINRLXlubG8qBZaio3oF1Ht5kX4Q/edit#}
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    class_id: number; // int, 必填，班级ID
    learn_status: 0 | 1 | 2; // int, 必填，学习任务状态 0：所有；1：已完成；2：未完成
    page: number; // int，选填，分页页码，默认值为1
    size: number; // int，选填，每页数据量，默认值为10
}

export interface ICreatorInfo {
    teacher_id: number;
    user_name: string;
    user_avatar: string;
}

export interface ILearnerTaskBaseInfo extends ITaskBaseInfo {
    teacher_avatar_arr: string[];
    cooperator_info: IUserBaseInfo[];
    creator_info: ICreatorInfo;
}

export interface ILearnerCourseTask extends ILearnerTaskBaseInfo {
    session_num: number; // 小节数目
    participated_num: number; // 参与人数
}

export interface ILearnerElementTask extends ILearnerTaskBaseInfo {
    participated_num: number; // 参与人数
    parent_id: number;
    parent_title: string;
    parent_url: string;
    obj_type: string;
}

export interface ILearnerProgramTask extends ILearnerTaskBaseInfo {
    module_num: number; // 阶段数目
    course_num: number; // 课程数目
    session_num?: number; // 小节数目
    open_module?: number;
}

export const getClassLearnerTaskList = (data: IInput): Promise<IListResponse<ITaskBaseInfo>> => {
    return fetchData(Api.CLASS_LEARNER_TASK_LIST, data).then((res: IListResponse<ITaskBaseInfo>) => {
        return res.data as IList<ITaskBaseInfo>;
    });
};
